import React, { FC } from 'react';
import { Alert, useTheme } from '@mui/material';
import { AlertType } from '../../../types/AlertType';
import boddVariables from '../../../variables.module.scss';

interface AlertComponentProps {
    Type: AlertType;
}

const AlertComponent: FC<AlertComponentProps> = (props) => {
    const { Type } = props;
    const theme = useTheme();
    const alertText = theme.alerts?.[Type]?.text ?? null;

    if (!alertText) {
        return null;
    }

    return (
        <Alert
            data-testid="AlertComponent"
            severity="info"
            sx={{
                textAlign: 'left',
                alignItems: 'center',
                mb: boddVariables.sp3,
            }}
        >
            {alertText}
        </Alert>
    );
};

export default AlertComponent;
